import { Button } from "components/DesignSystem/Button/Button";
import Loader from "components/DesignSystem/Loader/loader";
import Modal from "components/DesignSystem/Modal/Modal";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useGetAllInkleCPATeamsQuery } from "store/apis/internalTeamSetting";

export const ServiceTeamChangeModal = ({
  isOpen,
  onClose,
  serviceTeamId,
  onSubmit,
  isLoading,
}: {
  isOpen: boolean;
  onClose: () => void;
  serviceTeamId: string | null;
  onSubmit: () => void;
  isLoading?: boolean;
}) => {
  const { isAdmin } = useRoleBasedView();

  const { data: serviceTeams = [] } = useGetAllInkleCPATeamsQuery(
    {
      accessibleTeams: "CPA_TEAM",
    },
    { skip: !isAdmin }
  );

  const serviceTeam = serviceTeams.find((team) => team.uuid === serviceTeamId);

  const taskAssignmentMessage = serviceTeamId ? (
    <>
      You are about to assign this task to the{" "}
      <span className="t-font-bold">
        {serviceTeam?.name || <Loader size="small" />}
      </span>
      .
    </>
  ) : (
    "You are about to unassign the service team from this task."
  );

  const additionalMessage =
    "If a preparer is currently assigned, they may be unassigned, and a notification will be sent in the task chat.";

  const action = serviceTeam ? "Assign" : "Unassign";
  const buttonType = serviceTeam ? "primary" : "danger";

  return (
    <Modal.Root open={isOpen} onOpenChange={onClose}>
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>{action} Service Team</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body className="t-text-body-sm">
          {taskAssignmentMessage} {additionalMessage}
          <br />
          <br />
          Are you sure?
        </Modal.Body>
        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button>Cancel</Button>
          </Modal.RawClose>
          <Button
            customType={buttonType}
            isLoading={isLoading}
            disabled={isLoading}
            onClick={onSubmit}
          >
            Yes
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
